import { CentroCusto } from 'service/api'

import { CreateSlice } from './index'

export type CostCenterState = {
    costCenterId: number
    costCenter: CentroCusto | null
    setCostCenterId: (id: number) => void
}

export const createCostCenterSlice: CreateSlice<CostCenterState> = set => ({
    costCenterId: -1,
    costCenter: null,
    setCostCenterId: (id: number) => set({ costCenterId: id }),
})
